import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { MostRecentAvatars } from 'components/common/most-recent-avatars/MostRecentAvatars';
import { AvatarData } from 'components/common/most-recent-avatars/MostRecentAvatarTypes';
import SubSection from 'components/common/section/sub-section/SubSection';
import EmptyStateMessageBody from 'components/common/section/sub-section/EmptyStateMessageBody';
import { trackEmptyBadgeVisitForumsClick } from 'analytics/badgesAnalytics';
import { FORUMS_BADGES_DEFAULT_URL } from 'constants/index';

const MostRecentBadges = ({
  isPersonalView,
  recentBadges,
}: {
  isPersonalView: boolean;
  recentBadges: AvatarData[];
}) => {
  const isRecentBadgesZero = recentBadges.length === 0;

  //error state
  if (!isPersonalView && isRecentBadgesZero) {
    return null;
  }

  return (
    <div
      data-testid="most-recent-badges-container"
      css={[boxStyles, badgesStyle]}
    >
      <SubSection title={'MOST RECENT BADGES'}>
        {isRecentBadgesZero ? (
          <EmptyStateMessageBody
            message="Log in to Atlassian Community Forums to earn your first badge."
            linkTo={FORUMS_BADGES_DEFAULT_URL}
            linkType="external"
            sendAnalyticsEvent={() =>
              trackEmptyBadgeVisitForumsClick(isPersonalView)
            }
            linkText="Visit forums"
          />
        ) : (
          <MostRecentAvatars data={recentBadges} />
        )}
      </SubSection>
    </div>
  );
};

const boxStyles = css({
  width: '50%',
  borderRadius: token('border.radius'),
  borderWidth: token('border.width'),
  '@media (max-width: 768px)': {
    width: '100%',
  },
});

const badgesStyle = css({
  order: 2,
});

export default MostRecentBadges;
